export const data = [
  {
    'title': 'How to start a session',
    'content': 'This is a bunch of explanation about starting a session'
  },
  {
    'title': "What will happen if we can't get in contact with you",
    'content': "A bunch of explanation and text about what happens when you don't immediately get back to us"
  }
];